



























































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';


@Component({
  name: 'to-the-stars-tariff',
})
export default class ToTheStarsTariff extends Vue {
  @Prop({ type: Boolean })
  private readonly isActivated!: boolean;

  private handleActivate(): void {
    this.$modal.show('payment-card-modal');
  }
}
